<script setup lang="ts">
import { ref } from 'vue'
import { useExperienceStore } from '../stores/experience.store'

// Always shown to authenticated users in v3: everyone here came from v2, and
// switching back is always safe. The server maps the current page to its
// classic equivalent and records the choice.
const experience = useExperienceStore()
const switching = ref(false)

async function onClick(): Promise<void> {
  switching.value = true
  await experience.switchToClassic()
}
</script>

<template>
  <v-tooltip
    text="Switch back to the classic TAMI"
    location="bottom"
  >
    <template #activator="{ props: tip }">
      <v-btn
        v-bind="tip"
        variant="text"
        size="small"
        class="classic-view-btn mx-1 text-none"
        prepend-icon="fa-solid fa-clock-rotate-left"
        :loading="switching"
        aria-label="Switch to the classic TAMI experience"
        @click="onClick"
      >
        <span class="d-none d-lg-inline">Classic view</span>
      </v-btn>
    </template>
  </v-tooltip>
</template>

<style scoped lang="scss">
.classic-view-btn {
  letter-spacing: 0;
  font-weight: 600;
}
</style>
